import { makeAutoObservable, runInAction } from 'mobx';
import type { RootStore } from './root-store';
import { AlertStore } from './alert-store';

export class PartnerDialogStore {
    rootStore: RootStore;

    alertStore: AlertStore;

    activeModal: 'becomePartner' | 'sended' | null = null;

    loading = false;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;

        makeAutoObservable(this, {
            rootStore: false,
        });
    }

    closeDialog(): void {
        this.activeModal = null;
        this.rootStore.alertStore.clearAllMessages();
        this.rootStore.alertStore.setDefaultPlacement();
    }

    setBecomePartnerActive(keepMessages = false): void {
        runInAction(() => {
            this.activeModal = 'becomePartner';
        });
        this.rootStore.alertStore.setModalPlacement();
        if (!keepMessages) {
            this.rootStore.alertStore.clearAllMessages();
        }
    }

    setSendedActive(): void {
        this.activeModal = 'sended';
        this.rootStore.alertStore.setModalPlacement();
        this.rootStore.alertStore.clearAllMessages();
    }

    setLoading(loading: boolean) {
        this.loading = loading;
    }
}
